import React, {memo} from 'react';
import { AnimatePresence } from "motion/react";
import * as motion from "motion/react-client";
import { Select } from "antd";
import { DADATA_API_KEY } from '../../../config/secrets';
import { FioSuggestions, PartySuggestions, AddressSuggestions, EmailSuggestions } from "react-dadata";
import PhoneCountryMask from '../../../components/AddressCard/PhoneCountryMask';

// Компонент полей компании
const CompanyFieldsComponent = memo(({
                                         isDisabled,
                                         checkboxIsJuridic,
                                         formData,
                                         handleChange,
                                         handleChangeCompanyName,
                                         handleChangeCompanyHead,
                                         handleChangeFirstName,
                                         handleChangeLastName,
                                         setDirectField,
                                         listPhoneCountries,
                                         phoneMask,
                                         isFetching,
                                         t,
                                         ADDRESS_PHONE_COUNTRY,
                                         ADDRESS_PHONE,
                                         dadataKeys,
                                     }) => {

    return (
        <AnimatePresence mode="wait">
            {checkboxIsJuridic ? (
                <motion.div
                    key="juridic"
                    initial={{opacity: 0, y: -10}}
                    animate={{opacity: 1, y: 0}}
                    exit={{opacity: 0, y: -10}}
                    transition={{duration: 0.3}}
                >
                    <div className="cform-input-ctn">
                        <label className="cform-label">{t('name')}*</label>
                        <PartySuggestions
                            key={dadataKeys?.company || 0}
                            token={DADATA_API_KEY}
                            inputProps={{
                                className: 'cform-input',
                                name: 'company',
                                disabled: isDisabled,
                                onChange: handleChange,
                            }}
                            defaultQuery={formData.company}
                            count={4}
                            onChange={handleChangeCompanyName}
                        />
                    </div>
                    <div className="cform-inputs">
                        <div className="cform-input-ctn">
                            <label className="cform-label">{t('ogrn')}</label>
                            <input
                                className="cform-input"
                                type="text"
                                disabled={isDisabled}
                                name='company_ogrn'
                                onChange={handleChange}
                                value={formData.company_ogrn}
                            />
                        </div>
                        <div className="cform-input-ctn">
                            <label className="cform-label">{t('inn')}</label>
                            <input
                                className="cform-input"
                                type="text"
                                disabled={isDisabled}
                                name='company_inn'
                                onChange={handleChange}
                                value={formData.company_inn}
                            />
                        </div>
                        <div className="cform-input-ctn">
                            <label className="cform-label">{t('kpp')}</label>
                            <input
                                className="cform-input"
                                type="text"
                                disabled={isDisabled}
                                name='company_kpp'
                                onChange={handleChange}
                                value={formData.company_kpp}
                            />
                        </div>
                    </div>
                    <div className="cform-input-ctn">
                        <label className="cform-label">{t('supervisorFullName')}</label>
                        <FioSuggestions
                            key={dadataKeys?.companyHead || 0}
                            token={DADATA_API_KEY}
                            inputProps={{
                                className: 'cform-input',
                                name: 'company_head',
                                disabled: isDisabled,
                                onChange: handleChange,
                            }}
                            defaultQuery={formData.company_head}
                            count={4}
                            onChange={handleChangeCompanyHead}
                        />
                    </div>
                </motion.div>
            ) : (
                <motion.div
                    key="individual"
                    initial={{opacity: 0, y: -10}}
                    animate={{opacity: 1, y: 0}}
                    exit={{opacity: 0, y: -10}}
                    transition={{duration: 0.3}}
                >
                    <div className="cform-input-ctn">
                        <label className="cform-label">{t('firstName')}*</label>
                        <FioSuggestions
                            token={DADATA_API_KEY}
                            inputProps={{
                                className: 'cform-input',
                                name: 'first_name',
                                disabled: isDisabled,
                                onChange: handleChange,
                            }}
                            defaultQuery={formData.first_name}
                            count={4}
                            onChange={handleChangeFirstName}
                            filterParts={['name']}
                        />
                    </div>
                    <div className="cform-input-ctn">
                        <label className="cform-label">{t('lastName')}*</label>
                        <FioSuggestions
                            token={DADATA_API_KEY}
                            inputProps={{
                                className: 'cform-input',
                                name: 'last_name',
                                disabled: isDisabled,
                                onChange: handleChange,
                            }}
                            defaultQuery={formData.last_name}
                            count={4}
                            onChange={handleChangeLastName}
                            filterParts={['surname']}
                        />
                    </div>
                    <div className="cform-input-ctn">
                        <label className="cform-label">{t('Phone')}</label>
                        <PhoneCountryMask
                            extraClass="cform-input"
                            name="phone"
                            countries={listPhoneCountries}
                            country={formData.phone_country}
                            loading={isFetching}
                            phone={formData.phone}
                            phoneMask={phoneMask}
                            disabled={isDisabled}
                            handleChangeField={setDirectField}
                            nameCountry={ADDRESS_PHONE_COUNTRY}
                            namePhone={ADDRESS_PHONE}
                            fluid={true}
                            required
                        />
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
});

// Компонент полей адреса
const AddressFieldsComponent = memo(({
                                         isDisabled,
                                         formData,
                                         handleChange,
                                         handleChangeCountry,
                                         handleChangeCounty,
                                         handleChangeCity,
                                         handleChangeAddress,
                                         arrayCountries,
                                         regionList,
                                         regionData,
                                         selectedRegion,
                                         cleanCityName,
                                         t,
                                         dadataKeys,
                                     }) => {

    return (
        <AnimatePresence mode="wait">
            <motion.div
                key="address"
                initial={{opacity: 0, y: -10}}
                animate={{opacity: 1, y: 0}}
                exit={{opacity: 0, y: -10}}
                transition={{duration: 0.3}}
            >
                <div className='cform-inputs'>
                    <div className='cform-input-ctn'>
                        <label className='cform-label'>{t('country')}*</label>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            options={arrayCountries.map(country => ({
                                label: country.text + ' ' + country.emoji,
                                value: country.value
                            }))}
                            disabled={isDisabled}
                            className='cform-drop'
                            onChange={(value) => handleChangeCountry(value)}
                            value={formData.country}
                            placeholder={t('selectCountry')}
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </div>
                    {formData.country && (
                        <motion.div
                            className='cform-input-ctn'
                            initial={{opacity: 0, x: 10}}
                            animate={{opacity: 1, x: 0}}
                            exit={{opacity: 0, x: 10}}
                            transition={{duration: 0.3}}
                        >
                            <label className='cform-label'>{t('region')}*</label>
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                disabled={isDisabled}
                                options={regionList.map(region => ({
                                    label: region.text,
                                    value: region.value
                                }))}
                                className='cform-drop'
                                onChange={(value) => handleChangeCounty(value)}
                                value={formData.county}
                                placeholder={t('selectRegion')}
                                filterOption={(input, option) =>
                                    option.label.toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </motion.div>
                    )}
                </div>
                <div className='cform-inputs'>
                    <div className='cform-input-ctn'>
                        <label className='cform-label'>{t('locality')}</label>
                        <AddressSuggestions
                            key={dadataKeys?.city || 0}
                            token={DADATA_API_KEY}
                            inputProps={{
                                className: 'cform-input',
                                name: 'city',
                                disabled: isDisabled,
                                onChange: handleChange,
                            }}
                            defaultQuery={formData.city}
                            count={4}
                            onChange={handleChangeCity}
                            filterFromBound='city'
                            filterToBound='city'
                            filterLocations={
                                regionData && selectedRegion?.text !== 'Не задан'
                                    ? [{region: regionData.regionName, region_type: regionData.regionType}]
                                    : []
                            }
                        />
                    </div>
                    <div className='cform-input-ctn'>
                        <label className='cform-label'>{t('postalCode')}</label>
                        <input
                            className='cform-input'
                            type='text'
                            disabled={isDisabled}
                            name='mail_index'
                            onChange={handleChange}
                            value={formData.mail_index}
                        />
                    </div>
                </div>
                <div className='cform-input-ctn'>
                    <label className='cform-label'>{t('address')}</label>
                    <AddressSuggestions
                        key={dadataKeys?.address || 0}
                        token={DADATA_API_KEY}
                        inputProps={{
                            className: 'cform-input',
                            name: 'address',
                            onChange: handleChange,
                            disabled: isDisabled,
                        }}
                        defaultQuery={formData.address}
                        count={4}
                        onChange={handleChangeAddress}
                        filterLocations={
                            regionData && selectedRegion?.text !== 'Не задан' && cleanCityName
                                ? [{
                                    region: regionData.regionName,
                                    region_type: regionData.regionType,
                                    city: cleanCityName
                                }]
                                : cleanCityName
                                    ? [{city: cleanCityName}]
                                    : []
                        }
                    />
                </div>
                <div className='cform-input-ctn'>
                    <label className='cform-label'>{t('additionalAddressInfo')}</label>
                    <input
                        className='cform-input'
                        type='text'
                        disabled={isDisabled}
                        name='address_more'
                        onChange={handleChange}
                        value={formData.address_more}
                    />
                </div>
            </motion.div>
        </AnimatePresence>
    )
});

// Компонент контактных полей
const ContactFieldsComponent = memo(({
                                         isDisabled,
                                         checkboxIsJuridic,
                                         formData,
                                         handleChange,
                                         handleChangeFirstName,
                                         handleChangeLastName,
                                         handleChangeEmail,
                                         setDirectField,
                                         listPhoneCountries,
                                         phoneMask,
                                         isFetching,
                                         t,
                                         ADDRESS_PHONE_COUNTRY,
                                         ADDRESS_PHONE,
                                     }) => (
    <AnimatePresence mode="wait">
        {checkboxIsJuridic ? (
            <motion.div
                key="juridic-contact"
                initial={{opacity: 0, y: -10}}
                animate={{opacity: 1, y: 0}}
                exit={{opacity: 0, y: -10}}
                transition={{duration: 0.3}}
            >
                <div className="cform-input-ctn">
                    <label className="cform-label">{t('contactPerson')}*</label>
                    <div className="cform-input-ctn">
                        <FioSuggestions
                            token={DADATA_API_KEY}
                            inputProps={{
                                className: 'cform-input',
                                name: 'first_name',
                                placeholder: t('firstName'),
                                disabled: isDisabled,
                                onChange: handleChange,
                            }}
                            defaultQuery={formData.first_name}
                            count={4}
                            onChange={handleChangeFirstName}
                            filterParts={['name']}
                        />
                    </div>
                    <div className="cform-input-ctn">
                        <FioSuggestions
                            token={DADATA_API_KEY}
                            inputProps={{
                                className: 'cform-input',
                                name: 'last_name',
                                placeholder: t('lastName'),
                                disabled: isDisabled,
                                onChange: handleChange
                            }}
                            defaultQuery={formData.last_name}
                            count={4}
                            onChange={handleChangeLastName}
                            filterParts={['surname']}
                        />
                    </div>
                </div>
                <div className="cform-input-ctn">
                    <label className="cform-label">{t('jobTitle')}*</label>
                    <input
                        className='cform-input'
                        type='text'
                        name='job_title'
                        disabled={isDisabled}
                        onChange={handleChange}
                        value={formData.job_title}
                    />
                </div>
                <div className="cform-input-ctn">
                    <label className="cform-label">{t('phone')}*</label>
                    <PhoneCountryMask
                        extraClass="cform-input"
                        name="phone"
                        countries={listPhoneCountries}
                        country={formData.phone_country}
                        loading={isFetching}
                        phone={formData.phone}
                        phoneMask={phoneMask}
                        disabled={isDisabled}
                        handleChangeField={setDirectField}
                        nameCountry={ADDRESS_PHONE_COUNTRY}
                        namePhone={ADDRESS_PHONE}
                        fluid={true}
                        required
                    />

                </div>
                <div className="cform-input-ctn">
                    <label className="cform-label">{t('email')}</label>
                    <EmailSuggestions
                        token={DADATA_API_KEY}
                        inputProps={{
                            className: 'cform-input',
                            name: 'email',
                            disabled: isDisabled,
                            onChange: handleChange
                        }}
                        defaultQuery={formData.email}
                        count={4}
                        onChange={handleChangeEmail}
                    />
                </div>
                <div className='cform-input-ctn'>
                    <label className='cform-label'>{t('website')}</label>
                    <input
                        className='cform-input'
                        type='text'
                        name='website'
                        disabled={isDisabled}
                        onChange={handleChange}
                        value={formData.website}
                    />
                </div>
            </motion.div>
        ) : (
            <motion.div
                key="individual-contact"
                initial={{opacity: 0, y: -10}}
                animate={{opacity: 1, y: 0}}
                exit={{opacity: 0, y: -10}}
                transition={{duration: 0.3}}
            >
                <div className="cform-input-ctn">
                    <label className="cform-label">{t('email')}</label>
                    <EmailSuggestions
                        token={DADATA_API_KEY}
                        inputProps={{
                            className: 'cform-input',
                            name: 'email',
                            disabled: isDisabled,
                            onChange: handleChange
                        }}
                        defaultQuery={formData.email}
                        count={4}
                        onChange={handleChangeEmail}
                    />
                </div>
                <div className='cform-input-ctn'>
                    <label className='cform-label'>{t('website')}</label>
                    <input
                        className='cform-input'
                        type='text'
                        name='website'
                        disabled={isDisabled}
                        onChange={handleChange}
                        value={formData.website}
                    />
                </div>
            </motion.div>
        )}
    </AnimatePresence>
));

// Компонент полей сегментации
const SegmentationFieldsComponent = memo(({
                                              isDisabled,
                                              formData,
                                              updateField,
                                              usersOptions,
                                              industriesOptions,
                                              segmentsOptions,
                                              t
                                          }) => (
    <AnimatePresence mode="wait">
        <motion.div
            key="segment"
            initial={{opacity: 0, y: -10}}
            animate={{opacity: 1, y: 0}}
            exit={{opacity: 0, y: -10}}
            transition={{duration: 0.3}}
            className="cform-segmentation-form"
        >
            <div className='cform-inputs-column'>
                <div className='cform-input-ctn'>
                    <label className='cform-label'>{t('manager')}</label>
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        options={usersOptions.map(option => ({
                            label: option.text,
                            value: option.value
                        }))}
                        className='cform-drop'
                        disabled={isDisabled}
                        value={formData.manager === '0' && ''}
                        onChange={(value) => updateField('manager', value)}
                        notFoundContent={t('nothingFound')}
                        placeholder={t('selectManager')}
                        filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </div>
                <div className='cform-input-ctn'>
                    <label className='cform-label'>{t('administrator')}</label>
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        options={usersOptions.map(option => ({
                            label: option.text,
                            value: option.value
                        }))}
                        className='cform-drop'
                        disabled={isDisabled}
                        value={formData.administrator === '0' && ''}
                        onChange={(value) => updateField('administrator', value)}
                        notFoundContent={t('nothingFound')}
                        placeholder={t('selectAdministrator')}
                        filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </div>
            </div>
            <div className='cform-inputs-column'>
                <div className='cform-input-ctn'>
                    <label className='cform-label'>{t('areaActivity')}</label>
                    <Select
                        mode="multiple"
                        showSearch
                        style={{ width: '100%' }}
                        className='cform-drop'
                        onChange={(value) => updateField('industries', value)}
                        options={industriesOptions.map(option => ({
                            label: option.text,
                            value: option.value
                        }))}
                        disabled={isDisabled}
                        value={formData.industries}
                        placeholder={t('selectIndustries')}
                        filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </div>
                <div className='cform-input-ctn'>
                    <label className='cform-label'>{t('agriculturalSector')}</label>
                    <Select
                        mode="multiple"
                        showSearch
                        style={{ width: '100%' }}
                        options={segmentsOptions.map(option => ({
                            label: option.text,
                            value: option.value
                        }))}
                        className='cform-drop'
                        disabled={isDisabled}
                        onChange={(value) => updateField('segments', value)}
                        value={formData.segments}
                        placeholder={t('selectSegments')}
                        filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </div>
            </div>
        </motion.div>
    </AnimatePresence>
));

export {
    CompanyFieldsComponent,
    AddressFieldsComponent,
    ContactFieldsComponent,
    SegmentationFieldsComponent
};